import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { components } from '../api/tipos'
import type { Filtros } from './useFiltrosUrl'

export type ClienteResumen = components['schemas']['ClienteResumen']
export type PaginaClientes = components['schemas']['Pagina_ClienteResumen_']

/**
 * 200 filas por pagina: el reparto de una semana entra casi siempre de una vez,
 * y el backend ya limita el tamano maximo.
 */
export const TAMANO_PAGINA = 200

export function useClientes(filtros: Filtros, tamanoPagina: number = TAMANO_PAGINA) {
  const api = useApi()

  return useQuery<PaginaClientes, ErrorApi>({
    // `filtros` entero en la clave: al cambiar de pagina o de filtro la clave
    // cambia y TanStack Query no puede servir el resultado anterior.
    queryKey: ['clientes', filtros, tamanoPagina],
    queryFn: ({ signal }) =>
      api.pedir<PaginaClientes>('/api/clientes', {
        parametros: {
          semana: filtros.semana,
          ruta: filtros.ruta,
          // El buscador se llama `q` en la API; el cliente omite el vacio.
          q: filtros.q,
          page: filtros.page,
          page_size: tamanoPagina,
        },
        senal: signal,
      }),
  })
}
